
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(8(2796|3952|583|6313)|6(4174|7071|9618)|4(349|4923|5217|6119)|1((065|784|841)1|6342|9609)|9(3059|5750|7195|7756|8726)|7(1003|3050|3409|9675)|21471|2867|33307|36224|56083|58026)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
